import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const FALLBACK = {
  business: {
    name: "Harringtons Car Sales Ltd", trading_name: "Harrington's Direct",
    address: "38 London Road, Shenley, Hertfordshire, WD7 9EN", phone: "01923 857 457",
    email: "hcsales38a@aol.com", website: "https://hcsales.co.uk/", stock_url: "https://hcsales.co.uk/used-cars", opening_hours: "",
  },
  valuation: { available: false, mode: "unavailable" },
  is_tester: false,
};

const SiteCtx = createContext({ cfg: FALLBACK, reload: () => {} });

export function SiteProvider({ children }) {
  const [cfg, setCfg] = useState(null);
  const reload = useCallback(() => api.get("/public/config").then((r) => setCfg(r.data)).catch(() => setCfg(FALLBACK)), []);
  useEffect(() => { reload(); }, [reload]);
  return <SiteCtx.Provider value={{ cfg: cfg || FALLBACK, loaded: !!cfg, reload }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

const KEY = "hcs_journey";
const JourneyCtx = createContext(null);
const EMPTY = { valuation: null, manual: null, draft: null, step: 0, intent: null, partExchange: {}, vehicle: {}, contact: {}, marketing: false, photos: [], submitted: null };

export function JourneyProvider({ children }) {
  const [state, setState] = useState(() => {
    try { return { ...EMPTY, ...(JSON.parse(sessionStorage.getItem(KEY)) || {}) }; } catch { return EMPTY; }
  });
  useEffect(() => { sessionStorage.setItem(KEY, JSON.stringify(state)); }, [state]);
  const update = useCallback((patch) => setState((s) => ({ ...s, ...(typeof patch === "function" ? patch(s) : patch) })), []);
  const reset = useCallback((patch = {}) => setState({ ...EMPTY, ...patch }), []);
  return <JourneyCtx.Provider value={{ state, update, reset }}>{children}</JourneyCtx.Provider>;
}

export const useJourney = () => useContext(JourneyCtx);
